import { configureStore } from '@reduxjs/toolkit'

import { initialState } from './initialStoreState'
import { rootReducer } from './reducers/createReducers'

export const store = configureStore({
  devTools: true,
  reducer: rootReducer,
  preloadedState: initialState,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      // would be nice to enable this
      serializableCheck: false,
    }),
})
